import _ajax from './ajax';

const reqGameList = () => {
    return _ajax('/api/v1/gameList')
}

const reqUserInfo = data => {
    return _ajax('/api/v1/getUserInfo', data)
}

const reqServers = toGame => {
    return _ajax(`/api/games/getservers/${toGame}/false/false/false/true`)
}

const reqCheckUser = data => {
    return _ajax('api/v1/checkUserInfo', data)
}

const transferSubmit = data => {
    return _ajax('/api/v1/transferSubmit', data, 'POST')
}

const api_geetest = data => {
    return _ajax('/api/v1/geeRegister', data)
}

const loginVerify = data => {
    return _ajax('/api/v1/verify', data)
}

export {
    reqGameList,
    reqUserInfo,
    reqServers,
    reqCheckUser,
    transferSubmit,
    api_geetest,
    loginVerify
}